import { useState, useEffect } from "react";
import useApi from "./useApi";
import useAutoGet from "./useAutoGet";

export default function useStock() {
  //prop
  const { post, get } = useApi();

  return {
    //get all vendors
    getvendor() {
      return get(`admin/vendors`);
    },

    //Get all category
    getcategory() {
      return get(`quik/categories`);
    },

    //get products
 //get products (optionally by vendor_id)
getproducts(vendorId = null) {
  const url = vendorId ? `quik/product?vendor_id=${vendorId}` : "quik/product";
  return get(url);
},


    //get product variable
    getproVariable(product_id,vendor_id)
    {
      return get(`/quik/productvariable/${product_id}/${vendor_id}`)
    },





    //save
    addStock() {
      return post("/stocks",{
      onSuccess:(data, error, variables, context)=>{
      }, onError:(data, error, variables, context)=>{
      },onSettled:(data, error, variables, context)=>{
      }});
    },
  };
}
